import { useCallback } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { ehandoverAPI } from '../../../apis';
import { downloadFileById } from '../../../utils';
import { EHANDOVER_TAB_IDS, FIELD_FROM_BITRIX_API } from '../constants/config';

// 统一承接 EHandover 的导出流程。
// 这里把“组装导出 filter + 控制 exporting 状态 + 触发下载”收在一起，
// 让 index.js 不需要继续维护一整段与页面渲染无关的导出细节。
export default function useEhandoverExport({
  currentTabId,
  endDate,
  followUpFilter,
  handleFilter,
  loginInfo,
  search,
  setExportPopup,
  setExporting,
  showPinTab,
  sortOrder,
  startDate,
  tagNames,
}) {
  // 根据当前 active tab 生成导出接口需要的筛选条件。
  // 这里只保留现有导出规则，不改变每个 tab 导出的数据范围。
  const buildExportFilter = useCallback(() => {
    const filter = handleFilter({ search, startDate, endDate, tag: tagNames });

    if (currentTabId === EHANDOVER_TAB_IDS.SENT_TAB) {
      filter['!STATUS'] = 7;
      if (showPinTab) {
        filter.priority = 1;
      }
    } else if (currentTabId === EHANDOVER_TAB_IDS.DELETED_TAB) {
      filter.STATUS = 7;
    } else if (currentTabId === EHANDOVER_TAB_IDS.CHECKLIST_TAB) {
      filter.title = `₩${filter.title ? filter.title : '%'}`;
      filter.STATUS = followUpFilter === '2' ? [2, 3, 4] : [5];
    } else if (currentTabId === EHANDOVER_TAB_IDS.PIN_TAB) {
      filter['!STATUS'] = 7;
      filter.priority = 2;
    } else if (currentTabId === EHANDOVER_TAB_IDS.OUTSTANDING_TAB) {
      filter.STATUS = [2, 3, 4];
    } else if (currentTabId === EHANDOVER_TAB_IDS.COMPLETED_TAB) {
      filter.STATUS = [5];
    }

    return filter;
  }, [currentTabId, endDate, followUpFilter, handleFilter, search, showPinTab, startDate, tagNames]);

  // 真正执行导出。
  // 这里继续保留 sessionStorage 的导出标记逻辑，保证刷新页面后 exporting 状态还能恢复。
  const handleExport = useCallback(async () => {
    try {
      const select = _.filter(FIELD_FROM_BITRIX_API, (item) => item !== 'CHANGED_DATE');
      const filter = buildExportFilter();

      setExporting(true);
      sessionStorage.setItem('EHANDOVER_EXPORT', moment().add(40, 'minutes').format('x'));
      setExportPopup(false);

      await downloadFileById(
        () =>
          ehandoverAPI.getEhandoverExport({
            select,
            filter,
            order: sortOrder,
            wardId: loginInfo.wardId,
          }),
        () => `Ehandover Export Excel_${moment().valueOf()}`,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );

      setExporting(false);
      sessionStorage.removeItem('EHANDOVER_EXPORT');
    } catch (error) {
      console.log(error);
    }
  }, [buildExportFilter, loginInfo.wardId, setExportPopup, setExporting, sortOrder]);

  return {
    handleExport,
  };
}
